function mainRender() {
  $(function () {
    $('#root').css('zoom', 'normal')
    let scale = document.body.clientWidth / 1080
    $('#root').css('zoom', scale)

    window.addEventListener(
      'resize',
      (function () {
        var timer
        return function () {
          if (timer) clearTimeout(timer)
          timer = setTimeout(function () {
            $('#root').css('zoom', 'normal')
            let scale = document.body.clientWidth / 1080
            $('#root').css('zoom', scale)
          }, 100)
        }
      })()
    )
    // 生成随机时间
    function generateRandomTime() {
      var hours = Math.floor(Math.random() * 15) + 1
      var minutes = Math.floor(Math.random() * 60)
      var seconds = Math.floor(Math.random() * 60)
      //总共的毫秒数
      var targetTime = (hours * 3600 + minutes * 60 + seconds) * 1000

      return targetTime
    }
    function TimeDown(value) {
      //倒计时的总秒数
      var totalSeconds = parseInt(value / 1000)
      //取模（余数）
      var modulo = totalSeconds % (60 * 60 * 24)
      //小时数
      var hours = Math.floor(modulo / (60 * 60))
      modulo = modulo % (60 * 60)
      //分钟
      var minutes = Math.floor(modulo / 60)
      //秒
      var seconds = modulo % 60

      hours = hours.toString().length == 1 ? '0' + hours : hours
      minutes = minutes.toString().length == 1 ? '0' + minutes : minutes
      seconds = seconds.toString().length == 1 ? '0' + seconds : seconds

      //输出到页面
      $('.sp_hour').html(hours)
      $('.sp_minute').html(minutes)
      $('.sp_second').html(seconds)
      //延迟一秒执行自己
      if (hours == '00' && minutes == '00' && parseInt(seconds) - 1 < 0) {
      } else {
        setTimeout(function () {
          TimeDown(value - 1000)
        }, 1000)
      }
    }
    TimeDown(generateRandomTime())
    // 头部固定
    $('header').addClass('stiky')
    $(document).scroll(function (e) {
      var beforScrollTop = $(document).scrollTop()
      setTimeout(function () {
        $('header').addClass('stiky')
      }, 50)
    })
    // 轮播
    new Swiper('.mySwiper', {
      autoplay: {
        delay: 2000,
        stopOnLastSlide: false,
        disableOnInteraction: false,
      },
      loop: true, //循环滚动
      pagination: {
        el: '.swiper-pagination',
      },
    })
    // 初始化
    alignmentFns.initialize()
    // 数量
    let prods = window.product
    function getCur(){
      let color = $('.sp-color-wraper li.active').attr('data-val')
      let size = $('.sp-size-wraper li.active').attr('data-val')
       let save = $('.sp-save-wraper li.active').attr('data-val')
     
      return prods.filter(item=> item.option1 == color && item.option2 == size && item.option3 == save)[0]
    }
    function changePrice(){
      let num = $('#2').val()
      let price = (getCur().price * num / 100).toFixed(2)
      let compare = (getCur().compare_at_price * num / 100).toFixed(2)
      // price = (price + '').replace('.', ',')
      // compare = (compare + '').replace('.', ',')
      $('#new').html(price)
      $('#old').html(compare)
      // let off_font = 100 - Math.ceil(getCur().price / getCur().compare_at_price * 100)
      // $(".product-part .brand .num").html(off_font);
    }
    if (window.cartCount == 0) {
      $('.buy-car span').css('background', '#999')
    } else {
      $('.buy-car span').css('background', '#f24a00')
    }
    $('.sp-buynow').click(function(){
      let num = $('#2').val()
      window.location.href = '/cart/' + getCur().id + ':' + num
    })
    $('#addCart').click(function () {
      // do something here
      var data = {
        id: getCur().id,
        quantity: $('#2').val(),
      };
      $.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: data,
        success: function () {
          $.getJSON(window.Shopify.routes.root + "cart.js", function (result) {
            $(".buy-car span").html(result.item_count);
            if (result.item_count == 0) {
              $('.buy-car span').css('background', '#999')
            } else {
              $('.buy-car span').css('background', '#f24a00')
            }
          });
        },
        dataType: "json",
      });
      
      var img = $('.sp-pro-img img')
      var flyer = img[0].cloneNode(true)
      flyer.classList.add('clone')
      $('.sp-part5').append(flyer)
      $('.clone').css({
        width: '980px',
        height: '500px',
        position: 'fixed',
        top: img[0].offsetTop,
        left: img.offset().left,
        'z-index': '99',
      })
      var offset = $('.buy-car')[0].getBoundingClientRect()
      $('.buy-car').addClass('shake')
      setTimeout(() => {
        $('.buy-car').removeClass('shake')
      }, 1000)
      let finish = $('.buy-car')
      $('.clone').animate(
        {
          top: finish[0].offsetTop + 120,
          left: finish[0].offsetLeft + finish.width() / 2,
          width: 50, // 结束时的大小，根据需要调整
          height: 50, // 结束时的大小，根据需要调整
          opacity: 0.4,
        },
        1000,
        'linear',
        function () {
          $(this).animate(
            {
              width: 0,
              height: 0,
              opacity: 0,
            },
            0,
            function () {
              $(this).detach() // 完成动画后移除克隆的图片
            }
          )
        }
      )
    })
    $('#2').change(function () {
      changePrice()
      freeFunc()
    })
    // 包邮
    function freeFunc() {
      var freeShopping = 49.99
      if (Number($('#new').html().replace(',', '.')) >= freeShopping) {
        $('.sp-buynow').addClass('sp-freeshop')
      } else {
        $('.sp-buynow').removeClass('sp-freeshop')
      }
    }
 

     let spImgList = [ // Without display 1 当type==  Without display && 数量为1 
     'https://cdn.shopify.com/s/files/1/0811/6502/5580/files/20241021-pro-1.png?v=1731478133',
      'https://cdn.shopify.com/s/files/1/0811/6502/5580/files/20241021-pro-2.png?v=1731478356',
      'https://cdn.shopify.com/s/files/1/0811/6502/5580/files/20241021-pro-3.png',
      'https://cdn.shopify.com/s/files/1/0811/6502/5580/files/20241021-pro-4.png',
    ];
   let spImgList2 = [ //With display 2
      "https://cdn.shopify.com/s/files/1/0811/6502/5580/files/20241021-pro2-1.png",
  "https://cdn.shopify.com/s/files/1/0811/6502/5580/files/20241021-pro2-2.png?v=1731478480",
  "https://cdn.shopify.com/s/files/1/0811/6502/5580/files/20241021-pro2-3.png",
  "https://cdn.shopify.com/s/files/1/0811/6502/5580/files/20241021-pro2-4.png",
    ];
  let spImgList3 = [ //With display 1
    "https://cdn.shopify.com/s/files/1/0811/6502/5580/files/20241021-pro3-1.png",
    "https://cdn.shopify.com/s/files/1/0811/6502/5580/files/20241021-pro3-2.png",
    "https://cdn.shopify.com/s/files/1/0811/6502/5580/files/20241021-pro3-3.png",
    "https://cdn.shopify.com/s/files/1/0811/6502/5580/files/20241021-pro3-4.png",
    ];
    function changeChose() {
      var index = $('.sp-color-wraper li.active').index()
      var index2 = $('.sp-save-wraper li.active').index()
         console.log(index,index2)
      if(index2 == 0) {
         $('.sp-pro-img>img').attr('src', spImgList[index])
        }else if(index2 == 1){
        $('.sp-pro-img>img').attr('src', spImgList2[index])
        }else{
        $('.sp-pro-img>img').attr('src', spImgList3[index])
        }
    
    }
    // 颜色选择
    $('.sp-save-wraper li , .sp-size-wraper li,.sp-color-wraper li').click(function () {
      $(this).addClass('active').siblings().removeClass('active')
      changeChose()
      changePrice()
      freeFunc()
    })
    // $('.sp-color-wraper li').click(function () {
    //   var index = $(this).index()
    //  changeChose()
    //   changePrice()
    //   freeFunc()
    // })
    // $('.sp-save-wraper li,.sp-color-wraper li').click(function () {
    //   $(this).addClass('active').siblings().removeClass('active')
    //   changeChose()
    //   changePrice()
    //   freeFunc()
    // })
  })
  function lazyLoadImages() {
    // 懒加载
    const images = document.querySelectorAll('.lazy-load') // 获取所有需要懒加载的图片
    const config = {
      rootMargin: '0px 0px 1300px 0px',
      threshold: 0,
    }

    const lazyLoadObserver = new IntersectionObserver(function (
      entries,
      observer
    ) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          // 当图片进入视口时
          const image = entry.target
          const dataSrc = image.getAttribute('data-src')
          image.src = dataSrc // 将data-src属性的值设置为图片的实际地址
          lazyLoadObserver.unobserve(image) // 停止观察该图片
        }
      })
    },
    config)

    images.forEach(function (image) {
      lazyLoadObserver.observe(image) // 开始观察每个图片
    })
  }

  function preloadImages(imageArray) {
    // 预加载
    // 检查数组数据结构
    if (Array.isArray(imageArray[0])) {
      // 处理二维数组
      imageArray.forEach((subArray) => {
        subArray.forEach((url) => {
          const img = new Image()
          img.src = url
        })
      })
    } else {
      // 处理一维数组
      imageArray.forEach((url) => {
        const img = new Image()
        img.src = url
      })
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    lazyLoadImages()

    // preloadImages(imagesOneDim)
    // preloadImages(imagesTwoDim)

    // 找到所有跳转套餐的锚点链接
    var links = document.querySelectorAll('a[href^="#shopping"]')
    links.forEach(function (link) {
      link.addEventListener('click', function (event) {
        event.preventDefault() // 阻止默认的跳转行为
        // var targetElement = document.getElementById('shopping');
        // if (targetElement) {
        //     targetElement.scrollIntoView({ behavior: 'smooth' });
        // } // 方式一
        const targetElement = document.getElementById('shopping') // 获取跳转目标节点
        const offsetTop = targetElement.offsetTop
        window.scroll({
          top: offsetTop * $('div#root').css('zoom'),
          behavior: 'smooth', // 使用 smooth 实现平滑滚动
        }) // 方式二
      })
    })
  })

  // IOS字体多了间距的处理 给节点添加 sp_system 类名
  // 判断当前用户是安卓端还是iOS端
  var userAgent = navigator.userAgent || navigator.vendor || window.opera
  var isAndroid = /android/i.test(userAgent)
  var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream
  var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent) // 添加了对 "Iron" 关键词的判断

  if (isAndroid) {
    console.log('Android')
  } else if (isIOS) {
    console.log('iOS')
  } else if (isPC) {
    console.log('PC')
  } else {
    $('.sp_system').css('letter-spacing', '-4px')
  }
}

mainRender()
